import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { Highlight } from './Highlight';
import { guarantees, productImage } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-paper px-5 pb-16 pt-5 sm:pt-12 lg:pb-24 lg:pt-16" data-id="element-122" data-mp="9ipc3be1pe04">
      <div className="mx-auto flex max-w-6xl flex-col text-center lg:grid lg:grid-cols-[1fr_1fr] lg:grid-rows-[1fr_auto_auto_auto_auto_1fr] lg:gap-x-14 lg:text-left" data-id="element-123" data-mp="4njrqh0ak7e5">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="order-1 font-display text-[1.85rem] font-black leading-[1.06] tracking-tight text-ink sm:text-6xl lg:order-none lg:col-start-1 lg:row-start-2 lg:text-[4.1rem]" data-id="element-124" data-mp="xbflbcukdj6p">
          Plan Your Career Readiness Lessons{' '}
          <Highlight data-id="element-125" data-mp="381nuh8g0mr3f">in Minutes—Not Hours</Highlight>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease
      }} className="order-2 mx-auto mt-3 max-w-2xl text-[15px] font-semibold leading-snug text-ink sm:mt-6 sm:text-xl sm:leading-relaxed lg:order-none lg:col-start-1 lg:row-start-3 lg:mx-0" data-id="element-126" data-mp="3j7zgtn69y0is">
          Stop spending your evenings searching for activities, designing
          worksheets, and figuring out what to teach next.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease
      }} className="order-6 mx-auto mt-8 max-w-2xl sm:mt-4 lg:order-none lg:col-start-1 lg:row-start-4 lg:mx-0" data-id="element-127" data-mp="35aas2493698g">
          <p className="text-sm leading-relaxed text-ink-soft sm:text-lg" data-id="element-128" data-mp="2hjymh01bcol1">
            CAREER READY™ gives you six organized volumes of career exploration,
            workplace skills, practical activities, and assessment
            resources—so you can walk into class with a plan instead of
            starting from scratch.
          </p>
          <p className="mt-4 inline-block rounded-full bg-royal-light px-3 py-1.5 text-xs font-bold text-royal sm:mt-5 sm:text-sm" data-id="element-129" data-mp="iboyiltrcouw">
            For Middle &amp; High School Teachers · Designed Primarily for
            Grades 7–9
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease
      }} className="order-4 mx-auto mt-4 w-full max-w-[250px] sm:mt-8 sm:max-w-md lg:order-none lg:col-start-2 lg:row-span-6 lg:row-start-1 lg:mt-0 lg:max-w-none lg:self-center" data-id="element-130" data-mp="1ayt5uxgbpf9u">
          <img src={productImage} alt="The CAREER READY™ six-volume collection for middle and high school teachers" className="w-full" data-id="element-131" data-mp="3lu9tcq3qfe5y" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.18,
        ease
      }} className="order-5 mt-3 sm:mt-8 lg:order-none lg:col-start-1 lg:row-start-5" data-id="element-132" data-mp="1xa43telg8kjm">
          <CtaButton href="#checkout" data-id="element-133" data-mp="2b197qsvunyzr" />
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink-soft sm:mt-6 sm:text-sm lg:justify-start" data-id="element-134" data-mp="2b2ag2plhe7ds">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-135" data-mp="2kxc5lmjo5bgw" data-mpi={index}>
                <span data-id="element-136" data-mp="2p08ufuzsy3ta">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-137" data-mp="2tzlg4cext4ua">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}